const baseStyle = {
  control: {
    borderColor: `border`,
  },
  label: {
    cursor: `pointer`,
  },
};

const sizes = {
  sm: {
    control: { w: 4, h: 4 },
    icon: { fontSize: `0.625rem` },
  },
  xl: {
    control: { w: 8, h: 8 },
    icon: { fontSize: `1.5rem` },
  },
};

const variants = {
  default: {
    label: {
      color: `heading`,
    },
  },
  legal: {
    color: `legal`,
  },
};

const defaultProps = {
  variant: `default`,
};

export const Checkbox = {
  baseStyle,
  sizes,
  variants,
  defaultProps,
};
